/**
 * In a string, replace all text that is surrounded like ~~text~~
 * into strikethrough html
 */
export const convertMarkdownStyleStrikethroughToHtml = (inputString = '') => {
  if (!inputString) {
    return '';
  }

  return inputString.replaceAll(/~~(.*?)~~/g, (_, text) => {
    return `<s>${text}</s>`;
  });
};
